
import { useState, useEffect } from 'react';
import { servicesData } from '../../../mocks/servicesData';

interface ServiceNavProps {
  activeService: string;
  onServiceClick: (id: string) => void;
}

export default function ServiceNav({ activeService, onServiceClick }: ServiceNavProps) {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 520);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`${isSticky ? 'fixed top-[60px] left-0 right-0 z-40 bg-white/95 backdrop-blur-md shadow-md' : 'bg-white border-b border-gray-100'} transition-all duration-300`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-2 py-3 overflow-x-auto scrollbar-hide">
          {servicesData.map((service) => (
            <button
              key={service.id}
              onClick={() => onServiceClick(service.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                activeService === service.id
                  ? 'bg-amber-500 text-white shadow-md shadow-amber-500/30'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${service.icon} text-base`}></i>
              </div>
              {service.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
